import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { MdOutlineSearch } from 'react-icons/md';
import { useDebounce } from 'use-debounce';

import PageLayout from 'components/PageLayout';
import { AssociationMemberDto } from 'legacy/groups/types';

import AssociationAdminLayout from '../components/AssociationAdminLayout';
import MembersList from './components/MembersList';
import AffiliatedList from './components/AffiliatesList';
import RequestsList from './components/RequestsList';
import AdminsList from './components/AdminsList';
import MemberOptionsModal from './components/MemberOptionsModal';

const AssociationMembers = () => {
  const { query } = useRouter();
  const associationId = query.associationId as string;
  const [search, setSearch] = useState('');
  const [debouncedSearch] = useDebounce(search, 200);
  const [selectedMember, setSelectedMember] =
    useState<AssociationMemberDto | null>(null);

  const onSearchGuest = (event) => {
    setSearch(event.target.value);
  };

  const closeMemberOptionsModal = () => {
    setSelectedMember(() => null);
  };

  return (
    <AssociationAdminLayout>
      <PageLayout hidePageMenu isAdmin>
        <>
          <div className="pb-10">
            <div className="relative shrink-0 flex h-12 border-1 border-gray-300 rounded-full mt-5 mb-2">
              <MdOutlineSearch
                className="absolute left-3 text-gray-400 self-center justify-center"
                size={24}
              />
              <input
                type="text"
                className="w-full h-full px-11 rounded-full text-base text-gray-600 placeholder:text-gray-400"
                placeholder="Search"
                value={search}
                onChange={onSearchGuest}
              />
            </div>
          </div>
          <div className="flex gap-10 flex-col">
            <div className="flex flex-col-reverse md:flex-row gap-11">
              <AdminsList
                associationId={associationId}
                search={debouncedSearch}
                setSelectedMember={setSelectedMember}
              />
              <RequestsList
                associationId={associationId}
                search={debouncedSearch}
              />
            </div>
            <div className="flex flex-col md:flex-row gap-11">
              <MembersList
                associationId={associationId}
                search={debouncedSearch}
                setSelectedMember={setSelectedMember}
              />
              <AffiliatedList
                associationId={associationId}
                search={debouncedSearch}
              />
            </div>
          </div>
        </>
      </PageLayout>
      <MemberOptionsModal
        closeMemberOptionsModal={closeMemberOptionsModal}
        selectedMember={selectedMember}
        visible={!!selectedMember}
        associationId={associationId}
      />
    </AssociationAdminLayout>
  );
};

export default AssociationMembers;
